import { connect } from "react-redux";
import PosShipment from "./posShipment";
import { bindActionCreators } from "redux";
import {
  getPosShipment,
  getTagDelivery,
  getTags,
  postTagDelivery,
  updateStatus,
  updateStatusPos
} from "services/redux/installation/tagDelivery/action";
import { getSiteInspect,getPocBySiteId,
  postSendReportMail } from "services/redux/installation/siteInspection/action";
import { generateReport } from "services/redux/installation/materialRequisition/action";
import {getSiteData, calculateDistance, getDistanceData} from "../../../services/redux/DistanceCalculator/action";

const mapStateToProps = (state) => ({
  materialData: state.tagDeliveryReducer.tagData,
  tags: state.tagDeliveryReducer.tags,
  siteData: state.siteInspectionReducer.siteData,
  pocListBySiteId: state.siteInspectionReducer.pocListBySiteId,
  siteDetails: state.leadDataReducer.siteData,
  engDistanceData: state.leadDataReducer.engDistanceData,
  distanceDetails: state.leadDataReducer.distanceDetails,
  posRequirement: state.tagDeliveryReducer.posRequirement,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPosShipment,
      getTagDelivery,
      getTags,
      postTagDelivery,
      updateStatus,
      getSiteInspect,
      generateReport,
      getPocBySiteId,
      postSendReportMail,
      getSiteData,
      calculateDistance,
      getDistanceData,
      updateStatusPos
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PosShipment);
